/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetNewsList200ResponseDataCategoriesInner
 */
export interface GetNewsList200ResponseDataCategoriesInner {
  /**
   *
   * @type {string}
   * @memberof GetNewsList200ResponseDataCategoriesInner
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof GetNewsList200ResponseDataCategoriesInner
   */
  order: number
}

/**
 * Check if a given object implements the GetNewsList200ResponseDataCategoriesInner interface.
 */
export function instanceOfGetNewsList200ResponseDataCategoriesInner(
  value: object
): value is GetNewsList200ResponseDataCategoriesInner {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('order' in value) || value['order'] === undefined) return false
  return true
}

export function GetNewsList200ResponseDataCategoriesInnerFromJSON(
  json: any
): GetNewsList200ResponseDataCategoriesInner {
  return GetNewsList200ResponseDataCategoriesInnerFromJSONTyped(json, false)
}

export function GetNewsList200ResponseDataCategoriesInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsList200ResponseDataCategoriesInner {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    order: json['order'],
  }
}

export function GetNewsList200ResponseDataCategoriesInnerToJSON(
  value?: GetNewsList200ResponseDataCategoriesInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    order: value['order'],
  }
}
